export default "__VITE_ASSET__MUbv6G3v__"